import { Fragment } from 'react';
import {
  StaticPageLayout,
  Section,
  PageHero,
  CtaBanner,
  GroupLabel,
  FaqAccordion,
  OrangeButton,
  PhoneIcon,
} from 'app/components/StaticPages';
import { PHONE_NUMBER, PHONE_HREF } from 'app/core/constants';
import { FAQ_GROUPS } from './content';

const Faqs = () => (
  <StaticPageLayout
    title="Orlando Stroller Rental FAQs | Contact Us & Save Up To 50%"
    metaDescription="If you have any questions about renting strollers in Orlando, visit us or contact us today. Kingdom Strollers is the first choice in Orlando stroller rentals."
  >
    <PageHero
      align="center"
      maxWidth={900}
      eyebrow="Help Center"
      title="Frequently Asked Questions"
      subtitle="Can't find what you're looking for? Call us and a manager will answer your questions right away."
      subtitleMaxWidth={560}
    >
      <OrangeButton href={PHONE_HREF} sx={{ px: 3 }}>
        <PhoneIcon size={18} />
        Call {PHONE_NUMBER}
      </OrangeButton>
    </PageHero>

    <Section maxWidth={860} innerSx={{ pt: { xs: 5, md: 7 }, pb: 3 }}>
      {FAQ_GROUPS.map((group, groupIndex) => (
        <Fragment key={group.label}>
          <GroupLabel sx={{ mt: groupIndex === 0 ? 0 : 4, mb: 2 }}>
            {group.label}
          </GroupLabel>
          {group.items.map(item => (
            <FaqAccordion key={item.q} question={item.q}>
              {item.a}
            </FaqAccordion>
          ))}
        </Fragment>
      ))}
    </Section>

    <Section maxWidth={860} innerSx={{ pt: 3, pb: { xs: 6, md: 9 } }}>
      <CtaBanner
        title="Still have questions?"
        body="Call us — a manager answers every call, personally."
        cta={{ label: `Call ${PHONE_NUMBER}`, href: PHONE_HREF }}
      />
    </Section>
  </StaticPageLayout>
);

export default Faqs;
